module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/chocolate@2x_2f508e.jpg";